import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { EditorHero, MonoLabel, SectionCap, EditorialButton } from '../components/Editorial';
import FollowingPanel from '../components/recruit/FollowingPanel';

/**
 * Standalone /following page.
 *
 * Kept alive deliberately: whether non-athletes should be able to reach this
 * route is an open question, and settling it as a side effect of the Recruit
 * IA refactor would be the wrong way to decide it. See
 * docs/superpowers/specs/2026-08-10-web-recruit-ia-design.md §2.1.
 *
 * The list itself lives in FollowingPanel, shared with Recruit ▸ Following, so
 * the two entry points can never drift.
 */
export default function FollowingPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="ed-page">
      <EditorHero
        eyebrow={
          <>
            <MonoLabel onDark>RECRUITING · FOLLOWING</MonoLabel>
            <MonoLabel onDark>·</MonoLabel>
            <MonoLabel onDark>{user?.first_name?.toUpperCase()} {user?.last_name?.toUpperCase()}</MonoLabel>
          </>
        }
        headline="Your shortlist,"
        accent="kept current."
        sub="Follow the schools you care about and choose what you want to hear about — recruiting, games, NIL, and more."
      />

      {/* Pointer into the Recruit surface. Inside Recruit this card would be
          noise — Matches is a sibling tab there — so it lives on the page
          rather than in the panel. */}
      <SectionCap label="Matches" hint="FROM YOUR PROFILE" />
      <div className="ed-card ed-card--ink">
        <div className="ed-row ed-row--between" style={{ gap: 12, flexWrap: 'wrap' }}>
          <p className="ed-muted" style={{ margin: 0, fontSize: 13, minWidth: 0 }}>
            Ranked from your major, region, size, division and academics.
          </p>
          <EditorialButton onClick={() => navigate('/recruit?mode=schools&tab=matches')}>
            See my matches →
          </EditorialButton>
        </div>
      </div>

      <FollowingPanel />
    </div>
  );
}
